import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Alert from 'react-s-alert';

import { Accordion } from '../../components/Accordion';
import { Button } from '../../components/Button';
import { ButtonGroup } from '../../components/ButtonGroup';
import { BarChartComponent } from '../../components/BarChartComponent';
import { ColorFilter } from '../../components/ColorFilter';
import { CheckboxGroup } from '../../components/CheckboxGroup';
import { StatisticModal } from '../../components/StatisticModal';
import { ElementEdit } from '../../components/ElementEdit';
import { LocationDropdown } from '../../components/LocationDropdown';
import { LocationSelect } from '../../components/LocationSelect';
import { ModalComponent } from '../../components/Modal';
import { MinMaxFilter } from '../../components/MinMaxFilter';
import { NavigationWrapper } from '../../components/NavigationWrapper';
import { Upload } from '../../components/Upload';
import { SearchFilter } from '../../components/SearchFilter';

import { deleteConfirm } from '../../services/deleteConfirm';
import { formatBarChartData } from '../../services/formatChartData';
import { elementKeys } from '../../constants/elementProps';
import {
  toggleDisplayElement,
  handleElementUpdate,
  handleElementDelete,
  handleElementCreate,
  filterElements,
  searchElements,
  getAllElements,
  setColorFilter,
  getSingleElement,
  getAllElementsFilter,
  getDropdownFilters,
  initialFetchAll,
  clearFilters,
} from '../../actions/elements';

class HomeNavigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEdit: false,
      showCreateStatistic: false,
      showUpload: false,
      showSelectlocation: false,
    };
    this.handleShowEdit = this.handleShowEdit.bind(this);
    this.hideEdit = this.hideEdit.bind(this);
    this.hideStatistic = this.hideStatistic.bind(this);
    this.handleShowCreateStatistic = this.handleShowCreateStatistic.bind(this);
    this.handleElementUpdate = this.handleElementUpdate.bind(this);
    this.handleElementDelete = this.handleElementDelete.bind(this);
    this.handleMaterialTypeChange = this.handleMaterialTypeChange.bind(this);
    this.handlePositionChange = this.handlePositionChange.bind(this);
    this.handleLineChange = this.handleLineChange.bind(this);
    this.onUploadOpen = this.onUploadOpen.bind(this);
    this.onUplaodClose = this.onUplaodClose.bind(this);
    this.handleCloseSelectLocation = this.handleCloseSelectLocation.bind(this);
    this.handleShowSelectLocation = this.handleShowSelectLocation.bind(this);
    this.handleGetAllLocations = this.handleGetAllLocations.bind(this);
    this.handleElementFilter = this.handleElementFilter.bind(this);
    this.handleFilterClear = this.handleFilterClear.bind(this);
  }

  async componentDidMount() {
    if (
      this.props.filterProps.street &&
      this.props.filterProps.street.length > 0 &&
      this.props.filterProps.location &&
      this.props.filterProps.location.length > 0
    ) {
      await this.props.initialFetchAll(this.props.filterProps);
      await this.props.getAllElementsFilter(this.props.filterProps);
    }
  }

  handleShowEdit() {
    if (this.props.selectedElement) {
      this.setState({showEdit: true});
    } else {
      Alert.warning('Please select an element', {timeout: 2000});
    }
  }

  hideEdit() {
    this.setState({showEdit: false, showCreate: false});
  }

  hideStatistic() {
    this.setState({showCreateStatistic: false});
  }

  handleShowCreateStatistic() {
    this.setState({showCreateStatistic: true});
  }

  handleElementUpdate(element) {
    if (this.state.showCreate) {
      this.props.handleElementCreate(element);
    } else {
      this.props.handleElementUpdate(element);
    }
    this.hideEdit();
  }

  handleElementDelete() {
    if (this.props.selectedElement) {
      this.props.handleElementDelete([this.props.selectedElement.id]);
    } else {
      Alert.warning('Please select an element', {timeout: 2000});
    }
  }

  onUploadOpen() {
    this.setState({showUpload: true});
  }

  onUplaodClose() {
    this.setState({showUpload: false});
  }

  handleMaterialTypeChange(value) {
    this.props.getDropdownFilters(value, 'material_type', this.props.filterProps);
  }

  handlePositionChange(value) {
    this.props.getDropdownFilters(value, 'position', this.props.filterProps);
  }

  handleLineChange(value) {
    this.props.getDropdownFilters(value, 'line', this.props.filterProps);
  }

  handleCloseSelectLocation() {
    this.setState({showSelectlocation: false});
  }

  handleShowSelectLocation() {
    this.setState({showSelectlocation: true});
  }

  async handleGetAllLocations(props) {
    await this.props.getAllElements(props);
    await this.props.getAllElementsFilter(props);
  }

  handleElementFilter(values, name) {
    this.props.filterElements(values, name, this.props.filterProps);
  }

  async handleFilterClear() {
    const filers = this.props.filterProps;
    await this.props.clearFilters(filers);
    await this.props.getAllElements({
      street: filers.street,
      location: filers.location,
    });
  }

  render() {
    const {
      selectedElement,
      displayedElementProps,
      toggleDisplayElement,
      user,
      colorFilter,
      colorValues,
      getAllElements,
    } = this.props;
    const {
      showEdit, showCreateStatistic, showUpload, showSelectlocation,
    } = this.state;

    return (
      <NavigationWrapper>
        <ModalComponent
          big
          handleHide={this.handleCloseSelectLocation}
          open={showSelectlocation}
          title="SELECT LOCATIONS"
        >
          <LocationSelect
            getLocationAction={this.handleGetAllLocations}
            handleHide={this.handleCloseSelectLocation}
            onUploadOpen={this.onUploadOpen}
          />
        </ModalComponent>
        <ModalComponent
          handleHide={this.hideEdit}
          open={showEdit}
          title="EDIT"
        >
          <ElementEdit
            element={selectedElement}
            onSave={this.handleElementUpdate}
          />
        </ModalComponent>
        <ModalComponent
          handleHide={this.hideStatistic}
          open={showCreateStatistic}
          title="STATISTIC"
        >
          <StatisticModal
            elements={this.props.allElements.map((item) => ({date: item.date}))}
            elemntIds={this.props.allElements.map((item) => item.id)}
          />
        </ModalComponent>
        <ModalComponent
          handleHide={this.onUplaodClose}
          open={showUpload}
          title="UPLOAD FILES"
        >
          <Upload
            fetchAll={getAllElements}
            handleClose={this.onUplaodClose}
          />
        </ModalComponent>
        <div style={{height: '250px', position: 'relative'}}>
          <h3>
            {selectedElement ? `${selectedElement.street || '-'}, ${selectedElement.location || '_'}` : 'Please select element'}
          </h3>
          {selectedElement &&
            <div style={{position: 'absolute', left: '-30px'}}>
              <BarChartComponent
                height={150}
                measurements={selectedElement.measurements.map(formatBarChartData)}
                width={250}
              />
            </div>
          }
          <div style={selectedElement ? {marginTop: '190px'} : {}}>
            {selectedElement && user.admin &&
              <ButtonGroup>
                <Button
                  onClick={this.handleShowEdit}
                  type="seondary"
                >
                  EDIT
                </Button>
                <Button
                  onClick={() => deleteConfirm(this.handleElementDelete)} //eslint-disable-line
                  type="seondary"
                >
                  DELETE
                </Button>
              </ButtonGroup>
            }
          </div>
        </div>
        <Button
          block
          onClick={this.handleShowCreateStatistic}
          type="primary"
        >
          CREATE STATISTIC
        </Button>
        <Button
          block
          onClick={this.handleShowSelectLocation}
          type="primary"
        >
          SELECT LOCATION
        </Button>
        <hr />
        {user.admin &&
          <Button
            block
            onClick={this.onUploadOpen}
            type="secondary"
          >
            UPLOAD DOCUMENT
          </Button>
        }
        <hr />
        <hr />
        {this.props.filterProps.location.length > 0 && this.props.filterProps.street.length > 0 &&
        <Accordion
          data={[
            {
              title: 'Line Filter',
              content: (
                <LocationDropdown
                  items={this.props.lines}
                  onChange={this.handleLineChange}
                />
              ),
            },
            {
              title: 'Position Filter',
              content: (
                <LocationDropdown
                  items={this.props.positions}
                  onChange={this.handlePositionChange}
                />
              ),
            },
            {
              title: 'Material Filter',
              content: (
                <LocationDropdown
                  items={this.props.materialTypes}
                  onChange={this.handleMaterialTypeChange}
                />
              ),
            },
            {
              title: 'Element Props',
              content: (
                <CheckboxGroup
                  data={elementKeys}
                  handleToggle={toggleDisplayElement}
                  selected={displayedElementProps}
                />
              ),
            },
            {
              title: 'Remarks Filter',
              content: (
                <SearchFilter
                  label="Remarks"
                  onSubmit={this.handleElementFilter}
                />
              ),
            },
            {
              title: <span>R<sub>L</sub> Filter</span>, // eslint-disable-line
              content: (
                <MinMaxFilter
                  label="RL"
                  onSubmit={this.handleElementFilter}
                />
              ),
            },
            {
              title: 'Qd Filter',
              content: (
                <MinMaxFilter
                  label="Qd"
                  onSubmit={this.handleElementFilter}
                />
              ),
            },
            {
              title: 'Date Filter',
              content: (
                <MinMaxFilter
                  label="date"
                  onSubmit={this.handleElementFilter}
                />
              ),
            },
            {
              title: 'Application Date Filter',
              content: (
                <MinMaxFilter
                  label="application_date"
                  onSubmit={this.handleElementFilter}
                />
              ),
            },
            {
              title: 'Color Filter',
              content: (
                <ColorFilter
                  colorFilter={colorFilter}
                  colorValues={colorValues}
                  submit={this.props.setColorFilter}
                />
              ),
            },
          ]}
        />}
        <Button
          block
          onClick={this.handleFilterClear}
          type="primary"
        >
          CLEAR FILTERS
        </Button>
      </NavigationWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    allElements: state.elements.allElements,
    user: state.users,
    selectedElement: state.elements.selectedElement,
    locations: state.elements.locations,
    materialTypes: state.elements.materialTypes,
    positions: state.elements.positions,
    lines: state.elements.lines,
    displayedElementProps: state.elements.displayedElementProps,
    colorFilter: state.elements.colorFilter,
    colorValues: state.elements.colorValues,
    filterProps: state.elements.filterProps,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    toggleDisplayElement,
    handleElementUpdate,
    handleElementCreate,
    handleElementDelete,
    filterElements,
    getAllElements,
    searchElements,
    setColorFilter,
    getSingleElement,
    getAllElementsFilter,
    getDropdownFilters,
    initialFetchAll,
    clearFilters,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeNavigation);



// WEBPACK FOOTER //
// ./src/containers/Home/navigation.js